//
// Model Sync
//

import _ from "underscore";
import moment from "moment";
import LocalStorageModel from "../prototypes/LocalStorageModel";
import LocalStorage from "../prototypes/LocalStorageModel";
import { site_vars } from "../provider/siteVars";
import store from "@src/store";
import { AppSlice } from "@src/store/reducers/AppSlice";

class SyncModel extends LocalStorageModel<any> {
  name = "SyncModel";
  route = "apiSyncModel";
  backbonePattern = "Model";
  translated = false;
  privateApi = true;
  defaults() {
    return { version: false, asset_version: site_vars.asset_version };
  }

  initialize(attributes: any, options: any) {
    const model = this;
    // ObjectModel constructor heritage
    super.initialize.apply(model, [attributes, options]);
    //
    model.resetVersion();
    model.on("change:version", model.onChangeVersion);
    model.on("change:asset_version", model.onChangeAssetVersion);
    //sync.remoteFetch({async:false});
  }
  resetVersion() {
    const version = this.getVersion();
    store.dispatch(AppSlice.actions.setSyncVersion(version));
    site_vars.sync_version = version;
  }
  onChangeAssetVersion() {
    const model = this,
      test = model.testAssetVersion();
    if (!test) {
      model.softFetch();
      if (moment().diff(model.get("last_reload") || 0, "s") > 60) {
        // protection contre les récurrences
        // si on recharge à moins d'une minute d'intervale,
        // on annule.
        model.set("last_reload", new Date());
        model.setLocalStorageItem();
        // TODO: reload
        // window.location.reload(true);
      } else {
        //
        // TODO: implement error model
        // new ErrorModel("AssetInvalidationRecursion", model.toJSON());
        return true;
      }
    }
    return test;
  }
  testAssetVersion() {
    return this.getAssetVersion() === site_vars.asset_version;
  }
  test() {
    try {
      const model = this,
        key = model.getLocalStorageKey(),
        item = LocalStorage.ls.getItem(key),
        object = item ? JSON.parse(item) : {},
        localVersion = !_.isNull(object) ? object.version : "-1",
        testVersion = model.getVersion(),
        diff = !_.isNull(object) && localVersion !== testVersion;
      model.setLocalStorageItem();
      // renvoie true en cas de différence de version entre le localStorage et la version actuelle
      return diff;
    } catch (err) {
      // si le localStorage échoue
      // le test échoue
      return false;
    }
  }
  //
  getAssetVersion() {
    return this.get("asset_version");
  }
  getVersion() {
    return this.get("version") || "none";
  }
  getExpiresFromXHR(jqXHR: any) {
    return "0";
  }
  onChangeVersion(model: SyncModel) {
    try {
      LocalStorage.ls.clear();
    } catch (err) {}
    model.resetVersion();
    model.updateLocalStorageItem();
  }
}

export default SyncModel;
